<template>
<el-dialog :close-on-click-modal="false" append-to-body :visible.sync="show" title="渠道标签管理" width="400px">
  <div class="dialog-content" v-loading="isLoading"> 
    <el-button icon="el-icon-plus" @click="curTag = null; showCreateTag = true" type="primary">添加</el-button>
    <div class="list">
      <el-row v-for="(item, index) in tagList" :key="index" :gutter="12">
        <el-col :span="18">渠道标签{{ index + 1 }}: 
          <b>{{ item.label }}</b>
        </el-col>
        <el-col :span="6">
          <el-button type="text" @click="editTag(item)">编辑</el-button>
          <el-button type="text" @click="removeTag(item)" style="color: #f56c6c;">删除</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
  <div slot="footer" class="dialog-footer">
    <el-button type="primary" @click="$emit('close')">关闭</el-button>
  </div>

  <CreateTag v-if="showCreateTag" v-model="showCreateTag"
    :type="type"
    :editRow="curTag"
    @close="showCreateTag = false; curTag = null;"
    @on-success="tagSuccess"
   />
</el-dialog>
</template>
<script>
import CreateTag from './create-tag.vue'
import { getChannelTagList, delChannelTag } from '@/service/apis/supShopTag'

export default {
  components: {
    CreateTag
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    show: {
      handler (val) {
        if (val) {
          this.getChannelTagList()
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      isLoading: false,
      showCreateTag: false,
      tagList: []
    }
  },
  methods: {
    tagSuccess () {
      this.curTag = null
      this.showCreateTag = false
      this.getChannelTagList()
    },
    editTag (tag) {
      this.curTag = tag
      this.showCreateTag = true
    },
    removeTag (tag) {
      const loading = this.$loading({
        lock: true,
        text: '删除中...',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$confirm('删除无法恢复，确定要删除"' + tag.label + '"吗？', '提示').then(_ => {
        delChannelTag.call(this, [tag.id]).then(res => {
          this.$message.success('删除成功')
          this.getChannelTagList()
        }).finally(() => {
          loading.close()
        })
      })
    },
    async getChannelTagList () {
      this.isLoading = true
      const res = await getChannelTagList.call(this)
      this.isLoading = false
      this.tagList = [...(res || [])].map(item => ({
        label: item.tagLabel,
        value: item.tagCode,
        ...item
      }))
    }
  }
}
</script>

<style scoped>
::v-deep .el-dialog__body {
  padding: 12px 20px;
}
.list {
  padding-top: 16px;
}
.list ::v-deep .el-row {
  line-height: 24px;
  margin-bottom: 12px;
  border-bottom: solid 0.5px #e4e7ed;
}
.list ::v-deep .el-row:last-child {
  border-bottom: none;
}
.dialog-footer {
  text-align: center;
}
</style>
